import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PostDetail from './PostDetail';
import EditPost from './EditPost';
import './Feed.css';
import API_URL from '../config';

const Feed = ({ selectedCategory }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [editingPost, setEditingPost] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

useEffect(() => {
  fetchPosts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedCategory]);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      
      let url = `${API_URL}/api/posts`;
      if (selectedCategory && selectedCategory !== 'todas') {
        url += `?category=${selectedCategory}`;
      }
      
      const response = await axios.get(url);
      setPosts(response.data);
      setError(null);
    } catch (err) {
      setError('Error cargando los posts');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getCategoryLabel = (category) => {
    const labels = {
      'noticia': 'Noticia',
      'opinión': 'Opinión',
      'review-musical': 'Review Musical',
    };
    return labels[category] || category;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  // Filtrar posts por búsqueda local
  const filteredPosts = posts.filter(post => 
    post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    post.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="feed-container"><p>Cargando posts...</p></div>;
  if (error) return <div className="feed-container"><p className="error">{error}</p></div>;

  return (
    <div className="feed-container">
      <h1>contenido</h1>
      
      {/* Buscador compacto */}
      <div className="search-compact">
        <input
          type="text"
          placeholder="Buscar posts..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input-compact"
        />
      </div>

      {/* Contador de resultados */}
      {!loading && (
        <div className="results-count">
          {filteredPosts.length} {filteredPosts.length === 1 ? 'post encontrado' : 'posts encontrados'}
        </div>
      )}

      <div className="posts-grid">
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <article
              key={post._id}
              className="post-card"
              onClick={() => setSelectedPostId(post._id)}
            >
              {post.imageUrl && (
                <img src={post.imageUrl} alt={post.title} className="post-image" />
              )}
              <div className="post-content">
                <span className="category-badge">{getCategoryLabel(post.category)}</span>
                <h2>{post.title}</h2>
                <p className="post-description">{post.description}</p>
                <footer className="post-footer">
                  <span className="author">Por {post.author}</span>
                  <span className="date">{formatDate(post.createdAt)}</span>
                </footer>
              </div>
            </article>
          ))
        ) : (
          <p className="no-results">No hay posts que coincidan con tu búsqueda.</p>
        )}
      </div>

      {selectedPostId && (
        <PostDetail
          postId={selectedPostId}
          onClose={() => setSelectedPostId(null)}
          onEdit={(post) => {
            if (post) {
              setEditingPost(post);
              setSelectedPostId(null);
            } else {
              setSelectedPostId(null);
              fetchPosts();
            }
          }}
        />
      )}

      {editingPost && (
        <EditPost
          post={editingPost}
          onClose={() => setEditingPost(null)}
          onPostUpdated={fetchPosts}
        />
      )}
    </div>
  );
};

export default Feed;